import R from 'ramda'

export const getSiteTitle = R.path(['site', 'siteMetadata', 'title'])
export const getPost = R.path(['markdownRemark'])

export const getHtml = R.compose(
  R.prop('html'),
  getPost
)

export const getFrontMatter = R.compose(
  R.prop('frontmatter'),
  getPost
)


export const getImagePath = R.path(['image', 'childImageSharp', 'responsiveSizes', 'src'])

export const getImage = R.compose(
  getImagePath,
  getFrontMatter
)

export const getImageNode = R.compose(
  getImagePath,
  R.prop('frontmatter')
)

export const getPosts = R.path(['allMarkdownRemark', 'edges'])


// WEBPACK FOOTER //
// ./src/utils/selectors.js